import { render, staticRenderFns } from "./goodsAnalysis.vue?vue&type=template&id=70cbf4fd&scoped=true"
import script from "./goodsAnalysis.vue?vue&type=script&lang=js"
export * from "./goodsAnalysis.vue?vue&type=script&lang=js"
import style0 from "./goodsAnalysis.vue?vue&type=style&index=0&id=70cbf4fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cbf4fd",
  null
  
)

export default component.exports